import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { signOut, User } from 'firebase/auth';
import { LocalStorageService } from './local-storage.service';
import { LOCAL_STORAGE } from '../constants/local-storage.constants';
import { Router } from '@angular/router';
import { RiderService } from './rider.service';
import { RiderStatus } from '../models/rider.model';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private afAuth: AngularFireAuth,
    private localStorage: LocalStorageService,
    private router: Router,
    private riderService: RiderService
  ) {}
  async loginAnonymously(): Promise<User | null> {
    try {
      const credential = await this.afAuth.signInAnonymously();
      await this.setTokenInLocalStorage();
      return credential.user as User;
    } catch (error) {
      console.error('Anonymous login failed', error);
      return null;
    }
  }

  async getIdToken(): Promise<string | null> {
    const user = await this.afAuth.currentUser;
    if (user) {
      try {
        return await user.getIdToken();
      } catch (error) {
        console.error('Failed to retrieve ID token', error);
        return null;
      }
    }
    return null;
  }

  async logout() {
    try {
      const rider = this.localStorage.getItem(LOCAL_STORAGE.RIDER);
      this.riderService.updateRiderStatus(rider.riderId, RiderStatus.UNAVAILABLE)
      await this.afAuth.signOut();
      this.localStorage.clear();
      console.log('User logged out');
      this.router.navigate(['/welcome']);
    } catch (error) {
      console.error('Error during logout:', error);
    }
  }

  async setTokenInLocalStorage(): Promise<void> {
    const token = await this.getIdToken();

    if (token) {
      console.log('ID Token:', token);
      this.localStorage.setItem(LOCAL_STORAGE.TOKEN, token);
    } else {
      console.warn('No token retrieved');
    }
  }
}
